import Jobs from "../Settings/Scheduler/Jobs";

export default function ExternalScanJobs() {
  return (
    <div className="bg-gray-900 p-3 pb-20 min-h-screen text-gray-200">
      <div className="w-full mx-auto">
        {/* Jobs List Table */}
        <Jobs />
      </div>
    </div>
  );
}
